var render, staticRenderFns
import script from "./HeaderMain.js?vue&type=script&lang=js&"
export * from "./HeaderMain.js?vue&type=script&lang=js&"
import style0 from "./HeaderMain.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports